import styled from "styled-components";
import {flexColumnContainerMixin, flexRowContainerMixin} from "../../../../../../../themes/architecture/css-helpers/flex";

export const OptInHeaderRowContainerBox = styled.div`
    @media ${({theme}) => `${theme.mediaQuery.mAndBelow} and ${theme.mediaQuery.landscape}`} {
        ${flexRowContainerMixin}
    }

    display: flex;
    align-items: center;
    ${flexColumnContainerMixin}
    margin-top: 14px;
`